/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Spin,
  Col,
  Input,
  DatePicker,
} from 'antd';
import { capitalize } from 'utils/normalizers';
import { getMunicipios } from 'api/catalogos';
import Select from 'components/Select';
import AvatarUploader from 'components/AvatarUploader';

const CandidatoGeneral = ({
  form,
  rules,
  selectedRowKeys,
  paises,
  estados,
  generos,
  estadoCivil,
  nacionalidades,
  estadosCandidato,
  calcularEdad,
  isBlocked,
}) => {
  const MEXICANX = 1;
  const EXTRANJERX = 2;
  const PAIS_MEXICO = 152;

  const [loading, setLoading] = useState(false);
  const [municipios, setMunicipios] = useState([]);
  const [estadoRequired, setEstadoRequired] = useState(false);
  const [esNacional, setEsNacional] = useState(true);
  const [paisesList, setPaisesList] = useState(paises);

  const changeNacionalidad = async (nacionalidad, isFromEffect = false) => {
    setLoading(true);
    if (nacionalidad === EXTRANJERX) {
      setEsNacional(false);
      if (!isFromEffect) {
        form.setFieldsValue({
          pais: undefined,
          estado: undefined,
          lugar_de_nacimiento: undefined,
        });
      }
      setPaisesList(paises.filter((pais) => pais.id !== PAIS_MEXICO));
    } else if (nacionalidad === MEXICANX) {
      setEsNacional(true);
      if (!isFromEffect) {
        form.setFieldsValue({
          pais: PAIS_MEXICO,
          estado: undefined,
          lugar_de_nacimiento: undefined,
        });
      }
      setPaisesList(paises);
    }
    setLoading(false);
  };

  const changeState = async (estado) => {
    setLoading(true);
    form.setFieldsValue({
      estado_nacimiento: estado,
      lugar_de_nacimiento: undefined,
    });
    const _municipios = await getMunicipios({ estado });
    setMunicipios(_municipios);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    setEsNacional(form.getFieldValue('nacionalidad') === MEXICANX);

    const fetch = async () => {
      const estado = form.getFieldValue('estado');
      const _municipios = await getMunicipios({ estado });
      if (mounted) {
        setMunicipios(_municipios);
      }
    };
    fetch();
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    const nacionalidad = form.getFieldValue('nacionalidad');
    if (nacionalidad) {
      changeNacionalidad(nacionalidad, true); // 👈 evita que resetee campos
    }
  }, [form, selectedRowKeys]);

  return (
    <Spin tip="Cargando..." spinning={loading}>
      <Form
        layout="vertical"
        form={form}
        scrollToFirstError
        name="general"
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={8}>
            <AvatarUploader
              form={form}
              imageURL={form.getFieldValue('foto')}
            />
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="numero_de_candidato"
              // rules={rules.clave}
              label="No. Candidato"
            >
              <Input
                allowClear
                disabled
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="nombre"
              label="Nombre"
              rules={rules.required}
              hasFeedback
              normalize={capitalize}
            >
              <Input
                allowClear
                disabled={isBlocked}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="apellido_paterno"
              label="Apellido Paterno"
              rules={rules.required}
              hasFeedback
              normalize={capitalize}
            >
              <Input
                allowClear
                disabled={isBlocked}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="apellido_materno"
              label="Apellido Materno"
              rules={rules.required}
              hasFeedback
              normalize={capitalize}
            >
              <Input
                allowClear
                disabled={isBlocked}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="genero"
              label="Género"
              rules={rules.required}
              hasFeedback
            >
              <Select
                dataSource={generos}
                disabled={isBlocked}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="nacionalidad"
              label="Nacionalidad"
              rules={rules.required}
              hasFeedback
            >
              <Select
                dataSource={nacionalidades}
                onChange={changeNacionalidad}
                disabled={isBlocked}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="pais"
              label="País"
              rules={rules.required}
              hasFeedback
            >
              <Select
                dataSource={paisesList}
                labelProp="nombre"
                disabled={esNacional || !form.getFieldValue('nacionalidad') || isBlocked}
                onChange={(value) => {
                }}
                onSearch={(input) => {
                }}
                onSelect={(value) => {
                }}
                filterOption={(input, option) => (
                  option.label.toLowerCase().includes(input.toLowerCase())
                )}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="estado_nacimiento"
              label="Estado de Nacimiento"
              rules={rules.required}
              hasFeedback
              normalize={capitalize}
            >
              <Select
                dataSource={estados}
                labelProp="nombre_de_AGEE"
                disabled={!esNacional || isBlocked}
                onChange={(value) => {
                  if (value > 0) {
                    setEstadoRequired(true);
                    changeState(value);
                  } else if (value === undefined) {
                    setEstadoRequired(false);
                    form.resetFields(['lugar_de_nacimiento']);
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="lugar_de_nacimiento"
              label="Municipio de Nacimiento"
              hasFeedback
              rules={rules.required}
            >
              <Select
                dataSource={municipios}
                labelProp="nom_mun"
                disabled={!estadoRequired || !esNacional || isBlocked}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="fecha_de_nacimiento"
              label="Fecha de Nacimiento"
              rules={rules.required}
              hasFeedback
            >
              <DatePicker
                placeholder=""
                format="DD/MM/YYYY"
                onChange={(value) => {
                  form.setFieldsValue({
                    edad: calcularEdad(value),
                  });
                }}
                disabled={isBlocked}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="edad"
              label="Edad"
            >
              <Input
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="estado_civil"
              label="Estado Civil"
              rules={rules.required}
              hasFeedback
            >
              <Select
                dataSource={estadoCivil}
                disabled={isBlocked}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="tipo_sangre"
              label="Tipo de Sangre"
              rules={rules.required}
              hasFeedback
            >
              <Input
                allowClear
                disabled={isBlocked}
              />
            </Form.Item>
          </Col>
          {/* <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="tiene_hijos"
              label="Con Hijos"
            >
              <Select
                trueFalse
                allowClear
                disabled={isBlocked}
              />
            </Form.Item>
          </Col> */}

          {selectedRowKeys
            ? (
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="estado_del_candidato"
                  label="Estatus"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select dataSource={estadosCandidato} disabled />
                </Form.Item>
              </Col>
            )
            : (
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="estado_del_candidato"
                  label="Estatus"
                  rules={rules.required}
                  hasFeedback
                  initialValue={1}
                >
                  <Select dataSource={estadosCandidato} disabled />
                </Form.Item>
              </Col>
            )}

        </Row>
        <Form.Item hidden>
          <Button htmlType="submit" />
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default CandidatoGeneral;
